import Chart from "react-apexcharts";

const LineChart = ({ series }) => {
  const options = {
    legend: { show: false },
    theme: { mode: "light" },
    chart: { type: "line", toolbar: { show: false } },
    dataLabels: { enabled: false },
    stroke: { curve: "smooth" },
    tooltip: { theme: "dark" },
    grid: { show: true },
    xaxis: {
      categories: ["SEP", "OCT", "NOV", "DEC", "JAN", "FEB",],
      labels: {
        style: { colors: "#A3AED0", fontSize: "12px", fontWeight: "500" },
      },
    },
    yaxis: { show: true },
  };

  return <Chart options={options} type="line" width="100%" height="100%" series={series} />;
};

export default LineChart;
